import MojitoCore from 'mojito/core';
import MojitoApplications from 'mojito/applications';

import {stripRoutingPrefix} from '#core/utils/url-utils.js';
import {isValidIntent, openInternalIntent} from '#core/utils/intent-utils.js';

import {isHomeUrl, isInternalUrl} from '#core/application/utils.js';
import {ApplicationConfig} from '#core/config/application-config.js';

import {apiLog, wrapExternal} from './utils.js';

const IntentActions = MojitoCore.Intents.actions;
const reduxInstance = MojitoCore.Services.redux;
const {dispatch} = MojitoCore.Services.redux.store;

const {selectors: routerSelectors, actions: routerActions} = MojitoApplications.Common.RouterStore;

let internalRouteListener = null;

reduxInstance.actionListener.startListening({
    actionCreator: routerActions.routeChange,
    effect: data => {
        const {route} = data.payload;

        if (isInternalUrl(route) && internalRouteListener) {
            internalRouteListener(route);
        }
    },
});

export function setInternalRouteListener(val) {
    internalRouteListener = wrapExternal(val);
}

export function navigate(state, method, ...params) {
    let intent;
    apiLog.debug('navigate', method, ...params);

    if (!state.containerNode) {
        apiLog.warn(`Cannot navigate. ${PRODUCT_NAME} is not mounted`);

        return false;
    }

    if (!method) {
        // Sync router store with current history location path.
        // This is needed for cases when navigation is done outside lotto.
        // Include the query string so URLs like `/sportsbook?foo=bar` are not stripped to `/sportsbook`.
        const currentRoute = routerSelectors.selectRoute();
        const currentLocation = window.location.pathname + window.location.search;
        const pathChanged = currentLocation !== currentRoute;

        if (pathChanged) {
            dispatch(routerActions.routeChange({route: currentLocation, previousRoute: currentRoute}));
        }

        return true;
    }

    const currentSubPath = stripRoutingPrefix(ApplicationConfig.initParams.routingPrefix, window.location.pathname);

    if (method === currentSubPath) {
        // Path did not change. No need to navigate (or redirect).
        return true;
    }

    if (method === '/') {
        if (isHomeUrl(currentSubPath)) {
            // Already at home. No need to navigate.
            return true;
        }

        intent = openInternalIntent('toHome');
    } else if (method[0] === '/') {
        method = method.substring(1); // delete leading slash (moj specific)
        intent = openInternalIntent('toCustom', [method]);
    } else {
        intent = openInternalIntent(method, params);
    }

    if (isValidIntent(intent)) {
        dispatch(IntentActions.publishIntent(intent.type, intent.data));

        return true;
    }

    return false;
}
